import { prependAppName } from "shared/imports/sharedHelperFunctions"
import { makePieActionObjs } from "shared/imports/pieActionGenerators"

const appName = "@@politicalCommitteeProfile/"

const loadPoliticalCommitteeObjs = makePieActionObjs("load", "political_committee")
const loadPoliticalCommitteeActionDict = prependAppName(appName, loadPoliticalCommitteeObjs.pieDict)

const loadAffiliatedCommitteeObjs = makePieActionObjs("load", "affiliated_committee")
const loadAffiliatedCommitteeActionDict = prependAppName(appName, loadAffiliatedCommitteeObjs.pieDict)

const loadJointFundraisingCommitteeObjs = makePieActionObjs("load", "jfc")
const loadJointFundraisingCommitteeActionDict = prependAppName(appName, loadJointFundraisingCommitteeObjs.pieDict)

const loadJointFundraisingRepresentativeObjs = makePieActionObjs("load", "jfr")
const loadJointFundraisingRepresentativeActionDict = prependAppName(appName, loadJointFundraisingRepresentativeObjs.pieDict)

const loadCandidateObjs = makePieActionObjs("load", "candidate")
const loadCandidateActionDict = prependAppName(appName, loadCandidateObjs.pieDict)

const loadCommitteeTransactionSummaryObjs = makePieActionObjs("load", "transaction_summary")
const loadCommitteeTransactionSummaryActionDict = prependAppName(appName, loadCommitteeTransactionSummaryObjs.pieDict)

const PoliticalCommitteeActionTypes = {
    loadPoliticalCommitteeActionDict,
    loadCandidateActionDict,
    loadAffiliatedCommitteeActionDict,
    loadJointFundraisingCommitteeActionDict,
    loadCommitteeTransactionSummaryActionDict,
    loadJointFundraisingRepresentativeActionDict,
    UPDATE_POLITICAL_COMMITTEE: "UPDATE_POLITICAL_COMMITTEE",
}

export default PoliticalCommitteeActionTypes
